import { typeRampBaseFontSize, typeRampBaseLineHeight } from '@microsoft/fast-components';
import { robotoFontFamily } from '../styles/external/roboto-font';
export const bodyFontValue = robotoFontFamily;
export const typeRampBaseFontSizeValue = typeRampBaseFontSize.getValueFor(typeRampBaseFontSize.appliedTo[0]);
export const typeRampBaseLineHeightValue = typeRampBaseLineHeight.getValueFor(typeRampBaseLineHeight.appliedTo[0]);
// export const typeRampMinus1FontSizeValue = '12px';
// export const typeRampMinus1LineHeightValue = '16px';
// export const typeRampMinus2FontSizeValue = '10px';
// export const typeRampMinus2LineHeightValue = '16px';
// export const typeRampPlus1FontSizeValue = '16px';
// export const typeRampPlus1LineHeightValue = '24px';
// export const typeRampPlus2FontSizeValue = '20px';
// export const typeRampPlus2LineHeightValue = '28px';
// export const typeRampPlus3FontSizeValue = '28px';
// export const typeRampPlus3LineHeightValue = '36px';
// export const typeRampPlus4FontSizeValue = '34px';
// export const typeRampPlus4LineHeightValue = '44px';
// export const typeRampPlus5FontSizeValue = '46px';
// export const typeRampPlus5LineHeightValue = '56px';
// export const typeRampPlus6FontSizeValue = '60px';
// export const typeRampPlus6LineHeightValue = '72px';
